import { axiosPrivate } from "../../../api/axios";

export const getStepsForRole = async (roleId, userId, filters = {}) => {
  try {
    // console.log("📤 Sending to backend:", { roleId, userId, filters });
    const response = await axiosPrivate.post("/steps/by-role", {
      roleId,
      userId,
      filters, // ✅ include filters in the payload
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching steps for role:", error);
    throw error.response?.data || { message: "Error fetching steps." };
  }
};
